
//Wrapper for sliders
//NoUiSlider - http://refreshless.com/nouislider/

!function ($, noUiSlider) {

	if (!noUiSlider) {
		throw new Error("missing noUiSlider object");
	}

	function Slider($container, $slider, options) {
		this.init($container, $slider, options);
	}

	Slider.prototype = {

		init: function ($container, $slider, options) {

			this.$container = $($container);
			this.$slider = $($slider);
			this.$slider.appendTo(this.$container);

			this.options = this.setOptions(options);
			this.slider = window.noUiSlider.create(this.$slider[0], this.options);

			this.linkInputs();
		},

		reset: function () {
			if (this.slider) {
				this.slider.set([
					this.options.range.min,
					this.options.range.max
				]);

				//WF-2607: slider labels need to reset
				var $sliderLabels = this.$slider.find('.noUi-pips .noUi-value');
				var $parent = this.$slider.prev('.mk-inputrange-group');
				var $min = $parent.find('input[data-slider="min"]');
				var $max = $parent.find('input[data-slider="max"]');
				$sliderLabels.first().text($min.val());
				$sliderLabels.last().text($max.val());
			}
		},

		setOptions: function setOptions(options) {

			var $el = this.$container;

			options = options || {};
			options.connect = options.connect !== undefined ? options.connect : true;

			if (!options.range) {
				options.range = {
					min: parseFloat($el.attr('data-min') || 0),
					max: parseFloat($el.attr('data-max') || 0)
				};
			}

			var formatterLookup = {
				'dollar': '$0,0.00a',
				'number': '0,0.00',
				'magnitude': '0,0.00a',
				'percent': '0,0.00%'
			};

			var formatType = $el.attr('data-formatter');

			if (_.has(formatterLookup, formatType)) {
				options.format = {
					to: function(value) {
						return numeral(value).format(formatterLookup[formatType]);
					},
					from: function(value) {
						return numeral().unformat(value);
					}
				}
			}

			if (!options.pips) {
				 options.pips = {
					mode: 'values',
					values: [
						options.range.min,
						parseFloat($el.attr('data-median') || 0),
						options.range.max
					],
					density: -1
				};

				if (_.has(formatterLookup, formatType)) {
					options.pips.format = {
						to: function (value) {
							return numeral(value).format(formatterLookup[formatType]);
						}
					};
				}
			}

			options.start = options.start instanceof Array ? options.start : [];

			if (options.start[0] === undefined) {
				options.start[0] = options.range.min;
			}

			if (options.start[1] === undefined) {
				options.start[1] = options.range.max;
			}
			return options;
		},

		linkInputs: function linkInputs() {
		
			var $el = this.$container,
				$min = $el.find('input[data-slider=min]'),
				$max = $el.find('input[data-slider=max]'),
				slider = this.slider;

			slider.on('update', function (values, handle, rawValues, tap, explicit) {

				//explicit: user manually entered values
				//but values did not match with steps on the slider...
				if (explicit) return;

				var value = values[handle];

				if (handle == 0) {
					$min.val(value);
					return;
				}
				$max.val(value);
			});

			slider.on('change', function (values, handle) {

				if (handle == 0) {
					$min.trigger('change.mk-inputrange');
					return;
				}
				$max.trigger('change.mk-inputrange');
			});

			$min.on('change.mk-inputrange', function () {

				if (!this.value) {
					return;
				}

				slider.set([this.value, null], true);
			});

			$max.on('change.mk-inputrange', function () {

				if (!this.value) {
					return;
				}

				slider.set([null, this.value], true);
			});
		}
	};

	$.fn.slider = function (options) {
		return this.each(function () {

			var $el = $(this),
				data = $el.data('mk-slider');

			if (!data) {
				var $slider = $('<div aria-hidden="true" class="mk-slider" />'),
					 slider = new Slider($el, $slider, options);
				$el.data('mk-slider', slider);
			}
		});
	};

	$(function () {
		$('.mk-inputrange[data-toggle="slider"]').slider();
	});

	$(function () {
	    $(document.body).on('click', '.mk-inputrange-toggle', function (e) {
			e.preventDefault();

			var $self = this;
			var $el = $(e.target);
			var $container = $el.closest('.mk-inputrange-container');
            
			$container.find('li').removeClass('active');
			$el.closest('li').addClass('active');
			
			var $inputrange = $container.find('.mk-inputrange-group');
			var $buttonrange = $container.find('.mk-buttonrange-group');

			if ($self.getAttribute("data-control-type") == "slider") {
			    $container.find('.mk-inputrange-toggle-input').attr({ 'aria-selected': false});
			    $inputrange.addClass('hidden');
			    $buttonrange.removeClass('hidden');
			} else {
			    $container.find('.mk-inputrange-toggle-button').attr({ 'aria-selected': false});
			    $inputrange.removeClass('hidden');
			    $buttonrange.addClass('hidden');
			}
			$el.attr({ 'aria-selected': true});

			sendOmnitureData(this);
		});
	});

	function sendOmnitureData(caller) {
	    if (caller == null) {
	        return;
	    }
	    if (caller.baseURI.includes('Screeners/EquityAdvancedScreener')) {
	        Omniture.Track({ pageName: 'wfa:auth:Stock_Screener:Advanced Screener Page-Input Box', events: 'event95' });
	    }
	    if (caller.baseURI.includes('Screeners/EquityBasicScreener')) {
	        Omniture.Track({ pageName: 'wfa:auth:Stock_Screener:Basic Screener Page-Input Box', events: 'event93' });
	    }
    };

}(window.jQuery, window.noUiSlider);